// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import RegionStatus from "./region_status_type";


export default __t.object("Region", {
  id: __t.string(),
  displayName: __t.string(),
  wsUrl: __t.string(),
  httpUrl: __t.string(),
  get status() {
    return RegionStatus;
  },
  sortOrder: __t.u8(),
  updatedAt: __t.u64(),
});


